export const CREATE_MAIL_TEMPLATE  = 'CREATE_MAIL_TEMPLATE';
export const GET_MAIL_TEMPLATE  = 'GET_MAIL_TEMPLATE';
export const MAIL_TEMPLATE_REQUEST  = 'MAIL_TEMPLATE_REQUEST';
export const DELETE_MAIL_TEMPLATE  = 'DELETE_MAIL_TEMPLATE';
export const UPDATE_MAIL_TEMPLATE  = 'UPDATE_MAIL_TEMPLATE';
export const MAIL_TEMPLATE_REQUEST_FAILURE  = 'MAIL_TEMPLATE_REQUEST_FAILURE';
export const GET_MAIL_TEMPLATE_MODULE  = 'GET_MAIL_TEMPLATE_MODULE';
export const GET_MAIL_TEMPLATE_REQUEST_SUCCESS  = 'GET_MAIL_TEMPLATE_REQUEST_SUCCESS';